import Store from "./index.js"
import { createI18n } from 'vue-i18n'
import Handels from '@/utils/handels.js'
import messages from '@/languages/generateMessages.js'
import handels from "@/utils/handels.js";
export function L(key, ...args) {
    if (typeof(key) != "string") {
        return "";
    }
    key = key.toString().trim();
    //支付变量 __() __('')
    if (key.includes('__(')) {
        //console.log("tmp 1==",key)
        //reg __\([0-9,a-z]+\)
        const reg = /__\(([0-9,a-z]+)\)/i
        let match = key.match(reg)
        let s_key = key;
        if (match && match[1]) {
            let _key = match[0];
            let _val = match[1];
            key = key.replace(reg, match[1])
            let split_key = s_key.split(reg).pop().trim();
            //console.log("tmp split_key==",split_key)
            let find_val = Store.state.L(split_key, ...args)
                //console.log("tmp find_val 3==", find_val, ",_key==", key)
            if (args.length > 0 && key.indexOf('func') > -1) {
                //$L("__(funcDatetimeFormat)",data.value.createtime)
                //调用函数
                let func_name = key.replace("func", "").trim();



                find_val = Store.state.L("FUNCTIONS." + func_name, ...args)
                find_val = find_val.replace("__", args)
                window.$Log("tmp 4==", find_val, ",_key==", key, ",args==", args, ",func_name==", func_name)
                return find_val;

            } else if (find_val.length > 0 && (find_val !== key)) {

                match = find_val.match(reg)
                if (match && match[1]) {
                    console.log("替换后的key tmp 3 find_val == ", find_val, ",_val ==", _val, "_reg=", reg)
                    return find_val.replace(reg, _val)
                }
            }

        }

    }
    if (args.length == 1 && args == "object") {
        //返回一个对象
        const CurrentLangeuage = handels.CurrentLangeuage()
        const findKey = key
        const _val = (messages[CurrentLangeuage] && messages[CurrentLangeuage][findKey]) || {};
        return _val;
    }
    return Store.state.L(key, ...args)
}